// @flow

import React, { PureComponent, Fragment } from "react";
import { orderBy } from "lodash";
import type { HorseChange, RaceTypeCodeEnum } from "@tvg/types/Race";
import { formatPostTime, formatPeriod } from "@tvg/formatter/dates";

import RunnerNumber from "../../_atom/RunnerNumber";
import {
  Title,
  List,
  Time,
  Dl,
  Dt,
  Runner,
  EmptyStateLabel
} from "./styled-components";

type Props = {
  /**
   * List of horse changes
   */
  changes: Array<HorseChange>,
  /**
   * Race type code
   */
  raceTypeCode: RaceTypeCodeEnum,
  /**
   * Race Number
   */
  raceNumber: number
};

export default class HorseChanges extends PureComponent<Props> {
  static defaultProps = {
    changes: [],
    raceTypeCode: "T",
    raceNumber: 0
  };

  renderChanges = () => {
    const sortedChanges = orderBy(this.props.changes, ["date"], ["desc"]);

    return (
      <List>
        {sortedChanges.map((change) => (
          <li key={`horse-change-${change.date}-${change.runnerId}`}>
            <Time>
              {formatPostTime(change.date)} {formatPeriod(change.date)}
            </Time>

            <Dl>
              <Dt>
                <strong>Scratch</strong>
                <Runner>
                  <RunnerNumber
                    runnerId={change.runnerId}
                    raceTypeCode={this.props.raceTypeCode}
                  />
                </Runner>
                <strong>{change.horseName}</strong>
              </Dt>
            </Dl>
          </li>
        ))}
      </List>
    );
  };

  render() {
    return (
      <Fragment>
        <Title>
          Horses{!!this.props.raceNumber && ` - R${this.props.raceNumber}`}
        </Title>
        {!this.props.changes.length ? (
          <EmptyStateLabel>There are no horses changes</EmptyStateLabel>
        ) : (
          this.renderChanges()
        )}
      </Fragment>
    );
  }
}
